<template>
  <div class="tw:w-full tw:flex tw:flex-col tw:gap-y-1 tw:mb-6">
    <h1 class="tw:md:text-[32px] tw:text-xl tw:md:leading-[40px] tw:font-bold">{{ $t(title) }}</h1>
    <p class="tw:text-sm tw:md:text-base">{{ $t(subtitle) }}</p>
  </div>
</template>
<script setup>
defineProps({
  title: String,
  subtitle: String,
})
</script>
